import { render } from "./ModuleSummary.vue?vue&type=template&id=c7f7bc42"
import script from "./ModuleSummary.vue?vue&type=script&lang=js"
export * from "./ModuleSummary.vue?vue&type=script&lang=js"

import "./ModuleSummary.vue?vue&type=style&index=0&id=c7f7bc42&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__